module.exports = __webpack_public_path__ + "static/media/klarna.c14e60a0.svg";